export default __webpack_public_path__ + "static/media/tmobile_ideation.22c009a7.jpg";